import React, { useState, useEffect } from 'react';
import { Alert, Box, Title, Text, Button } from '@mantine/core';
import TabelResponsive from '../../components/TabelResponsive';
import RequestModal from '../../components/RequestModal';
import Typography from '@mui/material/Typography';
import Modal from '../../ui/Modal';
import { toast } from 'react-toastify';
import { dataLimita } from '../../constante';
import { usePlatforma, ultimaZiDeschisa } from '../../platforma';
import MesajInchidere from '../../components/MesajInchidere';

function RequestPage({ student, requestOptions, refresh }) {
    const SERVER = process.env.REACT_APP_SERVER;
    const [availableProfessors, setAvailableProfessors] = useState([]);
    const [requestModal, setRequestModal] = useState({ active: false, professor: null });
    const [deleteError, setDeleteError] = useState(null);
    const [hasDeletedRequest, setHasDeletedRequest] = useState(false);
    const [solicitare, setSolicitare] = useState(null);
    const [refuzateAutomat, setRefuzateAutomat] = useState([]);

    const handleSolicita = (id) => {
        setRequestModal({
            active: true,
            professor: availableProfessors.filter((prof) => prof.id === id)[0],
        });
    };

    const getBackendData = async () => {
        if (student.poateTrimite) {
            const res = await fetch(SERVER + 'user/profesori', requestOptions('GET'));
            const data = await res.json();
            if (data && data.listaProfesori)
                setAvailableProfessors(data.listaProfesori);
        }
        const res = await fetch(SERVER + 'solicitare/status', requestOptions('GET'))
        const data = await res.json();
        setSolicitare(data.solicitare || null);
        setRefuzateAutomat(data.refuzateAutomat || []);
    };

    useEffect(() => {
        student && getBackendData();
    }, [student]);

    const makeRequest = async (prof, title, message) => {
        const res = await fetch(SERVER + 'solicitare', {
            ...requestOptions('POST'),
            body: JSON.stringify({ idProfesor: prof.id, titlu: title, mesaj: message })
        });
        const data = await res.json();
        if (res.ok) {
            toast.success('Solicitare trimisă!');
            refresh();
        } else toast.error(data.error || 'Nu s-a putut trimite solicitarea!');
    };

    const retrimite = async (refuzata) => {
        const res = await fetch(SERVER + 'solicitare/retrimite', {
            ...requestOptions('POST'),
            body: JSON.stringify({ idSolicitare: refuzata.id }),
        });
        const data = await res.json();
        if (res.ok) {
            toast.success('Solicitare retrimisă!');
            refresh();
        } else toast.error(data.error || 'Nu s-a putut retrimite solicitarea!');
    };

    const updateRequestModal = (modal) => {
        setRequestModal({ ...modal });
    };

    const cancelRequest = async (e) => {
        e.preventDefault();
        const res = await fetch(SERVER + 'solicitare', {
            ...requestOptions('DELETE'),
            body: JSON.stringify({ idSolicitare: solicitare.id }),
        });
        const data = await res.json();
        if (data.error) setDeleteError(data.error);
        if (!data.error) {
            toast.success('Solicitare retrasă!');
            refresh();
        }
    };

    const { inchisa, dataInchidere } = usePlatforma();
    // dupa inchiderea platformei nu se mai pot trimite, retrimite sau retrage solicitari
    const poateSolicita = student?.e_repartizat === 0 && student?.poateTrimite && !inchisa;
    const ultimaZi = ultimaZiDeschisa(dataInchidere);
    const profesorSolicitat = solicitare?.Profesori;

    return (
        <Box bg="white" mt="35px">
           {/* <Text mt="30px" style={{ color: 'darkred', fontWeight: 'bold' }} align='center'>
                    Perioada de înscriere s-a încheiat. Nu mai poți iniția solicitări.
                </Text>*/}
            {inchisa ? (
                <MesajInchidere>
                    {student?.e_repartizat === 0 && (
                        <Text size="sm" mt="xs" fw={600}>
                            Dacă nu ai un profesor coordonator, directorul de departament te va repartiza manual.
                        </Text>
                    )}
                </MesajInchidere>
            ) : (
                <Alert color="blue" mb="lg"
                    title={`Platforma este disponibilă până la ${ultimaZi ? `${ultimaZi} inclusiv` : dataLimita()}`}>
                    Studenții care nu au un profesor coordonator până atunci vor avea alocat unul, manual,
                    de către directorul de departament.
                </Alert>
            )}
            {poateSolicita && refuzateAutomat.map((refuzata) => (
                <Alert key={refuzata.id} color="orange" mb="lg"
                    title={`Solicitarea către ${refuzata.profesor.nume} ${refuzata.profesor.prenume} a fost refuzată automat`}>
                    <Text size="sm">
                        Profesorul și-a ocupat toate locurile disponibile înainte să răspundă solicitării tale.
                        Nu este un refuz din partea profesorului. Poți trimite o solicitare altui profesor disponibil.
                    </Text>
                    {refuzata.poateRetrimite ? (
                        <>
                            <Text size="sm" mt="xs" fw={600}>
                                Profesorul are acum {refuzata.locuriLibere} {refuzata.locuriLibere === 1 ? 'loc liber' : 'locuri libere'}. Poți retrimite solicitarea.
                            </Text>
                            <Button mt="sm" color="orange" onClick={() => retrimite(refuzata)}>Retrimite solicitarea</Button>
                        </>
                    ) : (
                        <Text size="sm" mt="xs">
                            Dacă profesorul va primi locuri suplimentare, vei putea retrimite solicitarea de aici.
                        </Text>
                    )}
                </Alert>
            ))}
            {availableProfessors && availableProfessors.length > 0 && poateSolicita &&
                <Box>
                    <Title order={4}>Solicită colaborarea unuia dintre profesorii disponibili de mai jos.</Title>
                    <Text mb="25px">Odată lansată solicitarea, nu o poți retrage decât <b>peste 2 zile.</b></Text>
                    <Box align="center">
                        <TabelResponsive
                            columns={[{ label: 'Nume', id: 'nume' }, { label: 'Locuri', id: 'numarLocuri' }, { label: '', id: 'button' }]}
                            rows={availableProfessors.map((prof) => ({
                                id: prof.id, nume: `${prof.nume} ${prof.prenume}`, numarLocuri: prof.numarLocuriRamase
                            }))}
                            handler={handleSolicita} title='Profesorii disponibili din specializarea ta' />
                    </Box>
                </Box>
            }
            {(!availableProfessors || availableProfessors.length <= 0) && poateSolicita &&
                <Text mt="30px" style={{ color: 'darkred', fontWeight: 'bold' }} align='center'>
                    Nu mai sunt profesori disponibili pentru specializarea ta. Directorul de departament te va repartiza manual.
                </Text>}
            {student?.e_repartizat === 0 && !student?.poateTrimite ? (
                <Box align="center">
                    <Typography sx={{ mt: 6 }} align='center' component='p' variant='p'  >
                        Ai trimis o solicitare profesorului {profesorSolicitat && profesorSolicitat.nume + ' ' + profesorSolicitat.prenume}.
                        {inchisa
                            ? ' Platforma s-a închis înainte să primești un răspuns.'
                            : ' Te rugăm să aștepți un răspuns din partea sa. Succes!'}
                    </Typography>
                    <lottie-player src='https://assets8.lottiefiles.com/private_files/lf30_rgvpmzja.json' background='transparent'
                        speed='1' style={{ width: '300px', height: '300px' }} loop autoplay></lottie-player>
                    {deleteError && <Typography sx={{ mt: 3 }} align='center' component='p' variant='p' color='error'>{deleteError}</Typography>}
                    {!inchisa && <>
                    <Typography sx={{ mt: 3 }} align='center' component='p' variant='p' className='text-warning'>
                        Dacă nu primești răspuns în termen de 2 zile, ai posibilitatea să soliciți colaborarea unui alt profesor disponibil.
                    </Typography>
                    <Button type='button' mt="lg" onClick={() => setHasDeletedRequest(true)}>
                        Retrage solicitarea
                    </Button>
                    </>}
                    {!inchisa && hasDeletedRequest && (
                        <Modal open={true} closed={() => setHasDeletedRequest(false)}>
                            <Box>
                                <Typography align='center' component='h5' variant='h5' sx={{ mb: 2 }}>
                                    Ești sigur că vrei să îți retragi solicitarea de colaborare?
                                </Typography>
                                <Box>
                                    <Button variant='contained' color='success' sx={{ width: '48%', mx: '1%' }} onClick={(e) => { cancelRequest(e); setHasDeletedRequest(false); }}>
                                        Da
                                    </Button>
                                    <Button variant='contained' color='error' sx={{ width: '48%', mx: '1%' }} onClick={() => setHasDeletedRequest(false)}>
                                        Nu
                                    </Button>
                                </Box>
                            </Box>
                        </Modal>
                    )}
                </Box>
            ) : ('')}
            {!inchisa && requestModal.active && (
                <RequestModal makeRequest={makeRequest} updateRequestModal={updateRequestModal} modal={requestModal} />
            )}
        </Box>
    );
}

export default RequestPage;
